import { render, staticRenderFns } from "./optionTwo.vue?vue&type=template&id=45c2bf28&scoped=true"
import script from "./optionTwo.vue?vue&type=script&lang=js"
export * from "./optionTwo.vue?vue&type=script&lang=js"
import style0 from "./optionTwo.vue?vue&type=style&index=0&id=45c2bf28&prod&scoped=true&lang=css"
import style1 from "./optionTwo.vue?vue&type=style&index=1&id=45c2bf28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c2bf28",
  null
  
)

export default component.exports